module.exports = __webpack_public_path__ + "img/news-list-eng-2.73cec362.png";